<template>
  <div class="scroll-container">
    <v-list-item class="no-scroll">
      <v-list-item-title class="text-h6">{{ $t("MarkupViewsTitle") }}</v-list-item-title>
      <v-list-item-action @click="setSideDrawer(null)" style="cursor: pointer">
        <img class="vis-icon" src="/img/toolbar/Close.svg" />
      </v-list-item-action>
    </v-list-item>
    <v-divider></v-divider>
    <v-list class="pt-0 scroll">
      <v-list-item>
        <v-list-item-action @click="addMarkupView">
          <img class="vis-icon" src="/img/toolbar/cmdAdd24.svg" />
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("AddMarkupViewTooltip") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item v-for="(markupView, index) in markupViews" :key="index">
        <v-list-item-action @click="selectMarkupView(markupView)">
          <img :src="markupView.svgData" style="height: 100px; width: 100px; object-fit: contain" />
        </v-list-item-action>
        <v-list-item-action>
          <v-list-item-title>
            <v-textarea
              ref="descriptionArea"
              v-model="markupView.descriptionText"
              class="remove-border"
              auto-grow
              rows="1"
              hide-details
              :readonly="markupView.isReadOnly"
              @focus="$event.target.select()"
              @blur="leaveMarkupDescription(markupView)"
            ></v-textarea>
          </v-list-item-title>
        </v-list-item-action>
        <v-list-item-action>
          <v-tooltip left v-if="markupView.isReadOnly">
            <template v-slot:activator="{ on }">
              <div class="markup-view-icon" @click="editMarkupDescription(markupView, index)" v-on="on">
                <img class="vis-icon markup-view-icon" src="/img/toolbar/cmdEdit24.svg" />
              </div>
            </template>
            <span>{{ $t("EditMarkupDescriptionTooltip") }}</span>
          </v-tooltip>
          <v-tooltip left v-else>
            <template v-slot:activator="{ on }">
              <div class="markup-view-icon" @click="$refs.descriptionArea[index].blur()" @mousedown.prevent v-on="on">
                <img class="vis-icon markup-view-icon" src="/img/toolbar/cmdCheckmark24.svg" />
              </div>
            </template>
            <span>{{ $t("AcceptMarkupDescriptionTooltip") }}</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <div class="markup-view-icon" @click="deleteMarkupView(index)" v-on="on">
                <img class="vis-icon markup-view-icon" src="/img/toolbar/cmdDelete24.svg" />
              </div>
            </template>
            <span>{{ $t("DeleteMarkupViewTooltip") }}</span>
          </v-tooltip>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  components: {},
  data: () => ({
    markupViews: []
  }),
  computed: {
    ...mapGetters(["viewerManager", "snapshotManager", "markupManager"])
  },
  mounted: function() {
    this.$root.$on("modelLoaded", this.newModelLoaded);
  },
  methods: {
    ...mapMutations(["setSideDrawer"]),
    newModelLoaded: function() {
      this.markupViews = [];
    },
    addMarkupView: function() {
      var newMarkupView = {
        descriptionText: "Description",
        isReadOnly: true,
        viewData: this.markupManager.getMarkupViewData()
      };

      var imageCallback = function(data) {
        if (data) {
          newMarkupView.svgData = data;
          this.markupViews.push(newMarkupView);
        }
      }.bind(this);

      this.snapshotManager.enabled = true;
      this.markupManager.getMarkupViewImageExt(imageCallback);
    },
    selectMarkupView: function(markupView) {
      this.markupManager.showMarkupViewByData(markupView.viewData);
      this.setSideDrawer(null);
    },
    editMarkupDescription: function(markupView, index) {
      markupView.isReadOnly = false;
      this.$refs.descriptionArea[index].focus();
    },
    leaveMarkupDescription: function(markupView) {
      if (markupView.descriptionText === "") {
        markupView.descriptionText = "Description";
      }
      markupView.isReadOnly = true;
    },
    deleteMarkupView: function(index) {
      this.markupViews.splice(index, 1);
    }
  }
};
</script>

<style scoped>
.markup-view-icon {
  height: 36px;
  width: 36px;
}
</style>
